export const validations = () => {
    $(document).ready(function () {
        $('form').submit(function (ev) {
            ev.preventDefault();

            if (!$(this).parsley().isValid()) {
                $('#errorMessage').fadeIn();
            } else {
                var data = $(this).serialize();
                $.ajax({
                    url: "",
                    type: "post",
                    data: data,
                    headers: {Accept: "application/json"},
                    dataType: "json",
                    success: function (response) {
                        if (response.success) {
                            $('form input').val('');
                            $('form textarea').val("");
                            $('#thanks').fadeIn();
                            $('#errorMessage').fadeOut();

                            // Clears selected radio button on form submission
                            var inputs = document.querySelectorAll("input[type=radio]:checked"),
                                x = inputs.length;
                            while (x--) inputs[x].checked = 0;
                            ev.preventDefault();
                        }
                    },
                });
            }
        });
    });
}
